<script setup>
import { onMounted, reactive } from 'vue'

import FunnelForm from '@/components/FunnelForm.vue'
import PageV1 from '@/pages/PageV1.vue'
import PageV2 from '@/pages/PageV2.vue'
import { useAddressStore } from '@/stores/AddressStore'
import { useFormDataStore } from '@/stores/FormDataStore'
import { useSettingsStore } from '@/stores/SettingsStore'
import { useSubscriptionsStore } from '@/stores/SubscriptionsStore'
import { useVoucherStore } from '@/stores/VoucherStore'
import { useHelpers } from '@/useHelpers'

const state = reactive({
  selectedSubscription: ''
})

const dataStore = useFormDataStore()
const settingsStore = useSettingsStore()
const subscriptionsStore = useSubscriptionsStore()
const voucherStore = useVoucherStore()
const addressStore = useAddressStore()

const { sendMessage, inIframe } = useHelpers()
const handleWhatContains = (payload) => {
  sendMessage('triggerModal', {
    ...payload,
    type: 'subscriptionTypeInfo'
  })
}

const handleConfirmSubscription = () => {
  dataStore.setSelectedSubscription(state.selectedSubscription)
  voucherStore.resetVoucher()
}

onMounted(() => {
  subscriptionsStore.fetchMeta()
  subscriptionsStore.setAmount(0)

  const queryString = new URLSearchParams(window.location.search)
  const payload = queryString.get('payload')
  if (payload) {
    const prefill = JSON.parse(atob(payload))
    console.log('🎄 Processing prefill payload', { prefill })

    if (prefill.selectedSubscription) {
      dataStore.setSelectedSubscription(prefill.selectedSubscription)
    }
  } else {
    const selectedSubscription = queryString.get('selectedSubscription')
    if(selectedSubscription) {
      dataStore.setSelectedSubscription(selectedSubscription)
    }
  }

  state.selectedSubscription = subscriptionsStore.first.code

  window.addEventListener('message', (event) => {
    try {
      const data = JSON.parse(event.data)
      console.log('😈 Received message from parent', { data })

      if (data.action && data.action === 'confirmSelectedSubscriptionType') {
        handleConfirmSubscription()
      }

      if (data.type === 'pickupPointSelected') {
        addressStore.selectPacketaPickupPoint(data.point)
      }
    } catch (e) {
      // do nothing
    }
  })
})
</script>

<template>
  <main v-if="!dataStore.selectedSubscription" class="page-sales-funnel-pricing">
    <div v-if="subscriptionsStore.isMetaLoaded" class="container">
      <PageV1
        v-if="settingsStore.getVersion === 'CZ'"
        v-model="state.selectedSubscription"
        @on-what-contains-click="handleWhatContains"
      >
        <button
          v-if="!inIframe()"
          class="button button--large button--primary step-account__button"
          @click="handleConfirmSubscription"
        >
          {{ $t('Continue') }}
        </button>
      </PageV1>

      <div
          v-if="['SK','HU'].includes(settingsStore.getVersion)"
          class="pricing-page"
      >
        <PageV2
          v-model="state.selectedSubscription"
          @on-what-contains-click="handleWhatContains"
        >
        </PageV2>
      </div>
    </div>
  </main>

  <FunnelForm v-else />
</template>
